import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {Modal} from 'react-bootstrap';
import Swal from 'sweetalert2';
import config from '../../../config';

const DeleteSubjectModal = forwardRef((props, ref) => {

    const [modalBox, setModalBox] = useState(false);
    const [subId, setSubId] = useState('');


    useImperativeHandle(ref, () => ({
        openModal(subject_id) {
            setSubId(subject_id)
            setModalBox(true);            
        },  
    }));

    
    const removeSubject = async () => {
        try {
            // Define the API endpoint URL with subject_id
            const apiUrl = `${config.apiBaseUrl}/subject/removeSubject.php`; // Adjust the URL as needed
    
            // Create the data payload as an object
            const payload = {
                subject_id: subId,
            };

            // Make a DELETE request to the API with JSON payload using async/await
            const response = await fetch(apiUrl, {
                method: 'DELETE',
                headers: {
                'Content-Type': 'application/json',
                // Add any additional headers if needed (e.g., authorization token)
                },
                body: JSON.stringify(payload), // Convert the payload to JSON
            });
    
            if (!response.ok) {
            throw new Error(`Failed to delete data with ID ${subId}`);
            }
    
            console.log(`Data with ID ${subId} has been successfully deleted`);
            Swal.fire({
                icon: 'success',
                title: 'Delete successfull',
                text: `Data with ID ${subId} has been successfully deleted, please click refresh`,
            });
            setModalBox(false); // Close the modal after successful delete
            // Handle the success here
        } catch (error) {
            console.error(`Error deleting data with ID ${subId}: ${error.message}`);
            // Handle the error here
        }
};

  return (
    <>
            <Modal  onHide={setModalBox} show={modalBox} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Removal cannot be undone, please make sure!</h5>
                        <button type="button" className="btn-close"  onClick={()=>setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-12 col-lg-4 d-block">
                                    <div className="mb-3">
                                        <h1>Are you sure :{subId}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success light" onClick={removeSubject}>Yes remove</button>
                        <button type="button" className="btn btn-danger light" onClick={()=>setModalBox(false)}>Close</button>
                    </div>
                </div>                
            </Modal>
        </>
  )
})

export default DeleteSubjectModal
